import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import SelectDatesForAllDialog from '../dialogs/SelectDatesForAllDialog';
import { DEFAULT_CALENDAR_MIN_DAYS_FROM_TODAY } from '../../constants';
import useIsMobile from '../../hooks/useIsMobile';
import DEFAULT_SWITCH_CLASS_NAME from '../../theme/constants/switch';

const SelectDateForAllSwitch = ({
  setAllDates,
  setSameDateForAllSelection,
  useSelectDaysButtons,
  minDaysFromToday,
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleOnChange = (event, value) => {
    if (value) {
      setIsSelected(true);
      setIsOpen(true);
    } else {
      setIsSelected(false);
      setIsOpen(false);
      setSameDateForAllSelection(null);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsSelected(false);
  };

  const handleAccept = (dateValue) => {
    setAllDates(dateValue);
    setIsOpen(false);
    setIsSelected(true);
    setSameDateForAllSelection(dateValue);
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={1} sx={{ border: '1px solid', borderColor: 'gray.A200', borderRadius: 4, height: 32 }}>
        <Switch
          className={DEFAULT_SWITCH_CLASS_NAME}
          onChange={handleOnChange}
          checked={isSelected}
        />
        <Typography variant="small_2" fontWeight={600} sx={{ mr: 1 }}>
          Misma fecha para todas
        </Typography>
      </Box>
      <SelectDatesForAllDialog
        open={isOpen}
        handleClose={handleClose}
        isMobile={isMobile}
        onAccept={handleAccept}
        useSelectDaysButtons={useSelectDaysButtons}
        minDaysFromToday={minDaysFromToday}
      />
    </>
  );
};

SelectDateForAllSwitch.propTypes = {
  setAllDates: PropTypes.func.isRequired,
  setSameDateForAllSelection: PropTypes.func.isRequired,
  useSelectDaysButtons: PropTypes.bool,
  minDaysFromToday: PropTypes.number,
};

SelectDateForAllSwitch.defaultProps = {
  useSelectDaysButtons: true,
  minDaysFromToday: DEFAULT_CALENDAR_MIN_DAYS_FROM_TODAY,
};

export default SelectDateForAllSwitch;
